import { Outlet } from 'react-router-dom';

const Employee = () => {
  return <Outlet />;
};

export default Employee;
